// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nspan[data-v-faf2305a] {\n  font-size: 0.75em;\n}\n.v-item-group.v-bottom-navigation[data-v-faf2305a] {\n  margin-bottom: 40px;\n  height: 70px;\n  margin-top: 100px;\n}\n.v-item-group.v-bottom-navigation .v-btn[data-v-faf2305a] {\n  min-width: 60px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
